import { render, staticRenderFns } from "./SinglePointBasicInfoEditor.vue?vue&type=template&id=e8e0e240&"
import script from "./SinglePointBasicInfoEditor.vue?vue&type=script&lang=ts&"
export * from "./SinglePointBasicInfoEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports